import type { ReactNode } from 'react'
import { Box, HStack, VStack } from '@chakra-ui/react'
import { PLAY_DASHBOARD_BODY_BG } from '../mock-data'

const TODO_COLUMN_WIDTH = '334px'

interface IDesktopShellProps {
  header: ReactNode
  /**
   * Full-width organization/team banner under the header. Only an athlete who has
   * narrowed to an organization gets one — a coach's org banner is already the
   * header banner, so rendering it twice would be redundant.
   */
  orgBanner?: ReactNode
  /** Optional slots — skipped entirely when null so no empty spacing box renders. */
  streak?: ReactNode
  quickStats?: ReactNode
  teamFilter?: ReactNode
  nextUp?: ReactNode
  calendar: ReactNode
  todo: ReactNode
}

// Desktop content shell for /play-dashboard. Sidebar + Topbar are provided
// by VerticalLayout (the route is wrapped there in SubDomainRoutes), so this
// component only renders the page body: full-width sections stacked, with a
// final HStack pairing calendar (flex) + todo sidebar (fixed width).
const DesktopShell = ({
  header,
  orgBanner,
  streak,
  quickStats,
  teamFilter,
  nextUp,
  calendar,
  todo
}: IDesktopShellProps) => {
  return (
    <Box
      minHeight="100vh"
      width="100%"
      bg={PLAY_DASHBOARD_BODY_BG}
      px={4}
      py={{ base: 4, md: 6 }}
    >
      <VStack spacing="20px" align="stretch">
        <Box>{header}</Box>
        {orgBanner && <Box>{orgBanner}</Box>}
        {streak && <Box>{streak}</Box>}
        {quickStats && <Box>{quickStats}</Box>}
        {teamFilter && <Box>{teamFilter}</Box>}
        {nextUp && <Box>{nextUp}</Box>}
        <HStack spacing="20px" align="start" display={{ base: 'none', lg: 'flex' }}>
          <Box flex={1} minW={0}>
            {calendar}
          </Box>
          <Box w={TODO_COLUMN_WIDTH} flexShrink={0}>
            {todo}
          </Box>
        </HStack>
        <VStack
          spacing="20px"
          align="stretch"
          display={{ base: 'flex', lg: 'none' }}
        >
          <Box>{calendar}</Box>
          <Box>{todo}</Box>
        </VStack>
      </VStack>
    </Box>
  )
}

export default DesktopShell
